import { render, staticRenderFns } from "./NotesTaskContainer.vue?vue&type=template&id=5374c0b1&scoped=true&"
import script from "./NotesTaskContainer.vue?vue&type=script&lang=js&"
export * from "./NotesTaskContainer.vue?vue&type=script&lang=js&"
import style0 from "./NotesTaskContainer.vue?vue&type=style&index=0&id=5374c0b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5374c0b1",
  null
  
)

export default component.exports